var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13.293 9.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L8 6.414V18a2 2 0 0 0 2 2h10a1 1 0 1 0 0-2H10V6.414z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }